import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60ad36ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "modalDialog",
  class: "modal fade",
  id: "kt_modal_new_card",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Title Here", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 0,
  class: "modal-footer justify-content-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _hoisted_5
          ], true),
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = false))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "body", {}, undefined, true)
        ]),
        (_ctx.$slots.footer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}